import { fetchCurrentUser } from "@/api/authApi";

const permissionModule = {
  namespaced: true,
  state: {
    loaded: false,
  },
  mutations: {
    setLoaded(state, loaded) {
      state.loaded = loaded;
    },
  },
  actions: {
    async fetchPermission({ commit, rootState, dispatch }) {
      if (!rootState.auth.localUser) {
        await dispatch("auth/restoreSession", null, { root: true });
      }
      const res = await fetchCurrentUser();
      if (res?.code === 0 && res.data) {
        commit(
          "auth/setAuth",
          {
            localUser: res.data.user,
            isAdmin: res.data.isAdmin,
          },
          { root: true }
        );
      }
      commit("setLoaded", true);
      return res;
    },
  },
};

export default permissionModule;
